// extracted by mini-css-extract-plugin
export default {"modal":"wrGEi","clickable":"SJyZW","hideCheckboxes":"teioE","noWrap":"lvKsb","boolean":"zPojs","table":"h3oLr","tableDiv":"Pv4Jn","buttons":"lQBEu"};